<template>
  <b-navbar toggleable="lg" type="dark"
            :class="`pl-3 pr-3 w-100 cs-navbar ${getNavPosition} ${getNavStage}`">
    <b-navbar-brand href="/" class="cs-navbar-brand order-0 order-md-0">
      <b-img :src="getImageSrc" alt="Shautt logo" class="d-inline-block"/>
      <span>{{content.brand.name}}</span>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" hidden></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- Center aligned nav items -->
      <b-navbar-nav class="mx-auto order-1">
        <b-nav-item href="/#" hidden>
          <span class="cs-navbar-item">COMO FUNCIONA</span>
        </b-nav-item>
        <b-nav-item href="/#" hidden>
          <span class="cs-navbar-item">FAQ's</span>
        </b-nav-item>
        <b-nav-item :href="content.aboutUs.link" hidden>
          <span class="cs-navbar-item">{{ content.aboutUs.text }}</span>
        </b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="order-2" hidden>
        <b-nav-item v-if="!logged">
          <b-button class="cs-navbar-sign-in">
            <span>SIGN IN</span>
          </b-button>
        </b-nav-item>
        <b-nav-item-dropdown right v-if="logged">
          <template #button-content>
            <em>User</em>
          </template>
          <b-dropdown-item href="#">Profile</b-dropdown-item>
          <b-dropdown-item href="#">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { getImageSrc } from '@/utils/assets';

export default {
  name: 'NavBar',
  props: {
    content: Object,
  },
  created() {
    this.isHomePage = this.$router.history.current.name === 'Home';
    if (this.isHomePage) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  destroyed() {
    window.addEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      logged: false,
      scrollPos: window.scrollY,
      isHomePage: true,
    };
  },
  computed: {
    getImageSrc() {
      return getImageSrc(this.content.brand.iconSrc) || '';
    },
    getNavStage() {
      let stage = 'stage1';
      if (this.isHomePage && this.scrollPos < 80) {
        stage = 'stage0';
      }
      return stage;
    },
    getNavPosition() {
      let customPositionClass = '';
      if (this.isHomePage) {
        customPositionClass = 'home-bar';
      }
      return customPositionClass;
    },
  },
  watch: {
    $route(to) {
      this.isHomePage = to.name === 'Home';
    },
  },
  methods: {
    handleScroll() {
      this.scrollPos = window.scrollY;
    },
    getImagePath(imageName) {
      return getImageSrc(imageName);
    },
  },
};
</script>

<style lang="scss">
.cs-navbar {
  z-index: 10;
  transition: background-color 1s;
  &.stage0 {
    background-color: transparent;
  }
  &.stage1 {
    background-color: $brandPrimaryColor;
  }
  &.home-bar {
    position: fixed;
  }
}

.cs-navbar-brand {
  font-weight: $brandTitleWeight;
  font-size: $brandTitleSize;
  color: $headerPrimaryColor;
  &:hover {
    opacity: 85%;
  }
}

.cs-navbar-item {
  font-weight: $brandSubTitleWeight;
  font-size: $brandSubTitleSize;
  color: $headerPrimaryColor;
  &:hover {
    color: $brandSecondaryColor;
  }
}

.cs-navbar-sign-in {
  background-color: $brandSecondaryColor;
  font-weight: $brandSubTitleWeight;
  font-size: $brandSubTitleSize;
  color: $brandPrimaryColor;
    &:hover {
      color: $brandPrimaryColor;
    }
}

</style>
